<template>
  <div v-loading="loading" class="dashboard-area">
    <div class="flex align-center justify-between sale-instant-header">
      <div class="flex align-center">
        <i class="iconfont iconjinrikanban"></i>
        <span class="size14 area-tit">今日看板</span>
        <gj-help font-size="16px" v-if="active==='sale'">
          数据来源：亚马逊销售订单<br>
          使用说明：默认按所有站点当前市场时间进行计算，可自行切换指定时区进行数据展示，切换时区后下次进入默认显示上次选择时区；已取消订单不计入，其他所有订单状态参与计算，将导致销售相关字段数据虚高。
        </gj-help>
        <gj-help font-size="16px" v-if="active==='stock'">
          数据来源：亚马逊报表+自营仓数据<br>
          计算规则：<br>
          总库存=FBA总库存+自营仓总库存；<br>
          FBA总库存=可售+不可售+预占+在途+待出运；<br>
          自营仓总库存=可用量+次品量+预占量+已下单量；<br>
          使用说明：以所有站点当前市场时间进行计算，已取消订单不计入，其它所有状态参与计算，将导致销售相关字段数据虚高。
        </gj-help>
        <i class="iconfont iconshuaxin" @click="refresh"></i>
      </div>

      <div>
        <gj-radio-group
            v-model="active"
            :options="[{id: 'sale', text: '销售看板'},{id: 'stock', text: '库存看板'},{id: 'settlement', text: '结算看板'},]"
        ></gj-radio-group>
      </div>
    </div>

<!--    销售看板-->
    <app-sale-board
        ref="saleBoard"
        v-show="active==='sale'"
    ></app-sale-board>

<!--    库存看板-->
    <app-stock-board
        ref="stockBoard"
        v-show="active==='stock'"
    ></app-stock-board>

<!--    结算看板-->
    <app-settlement-board
        ref="settlementBoard"
        v-show="active==='settlement'"
    ></app-settlement-board>

    <app-mask></app-mask>
  </div>
</template>

<script>
import AppMask from "@/views/modules/home/components/mask/mask"
import AppStockBoard from "./components/stock-board"
import AppSettlementBoard from "./components/settlement-board"
import AppSaleBoard from "./components/sale-board"
import {isMeaningless} from "@/utils/common";

export default {
  name: "app-dashboard-sale-instant",
  components: {AppSaleBoard, AppStockBoard, AppSettlementBoard, AppMask},
  data() {
    return {
      active: 'sale',
      loading: false,
    }
  },
  methods: {
    refresh(){
      if(this.active==='sale'){
        this.$refs.saleBoard.$gjQuery()
      }
      if(this.active==='stock'){
        this.$refs.stockBoard.$gjQuery()
      }
      if(this.active==='settlement'){
        this.$refs.settlementBoard.$gjQuery()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";

.dashboard-area {
  padding-top: 0;

  /deep/ .el-radio-button__inner {
    padding: 6px 13px;
    font-size: 12px;
  }

  .sale-instant-header {
    height: 50px;
  }
}

/deep/ .bgBlue {
  background-color: #EDF7FF;
}

/deep/ .bgGreen {
  background-color: #E7F8EA;
}

/deep/ .bgPurple {
  background-color: #F7F2FC;
}

/deep/ .bgRed {
  background-color: #FFF1F0;
}
</style>
